const CART_KEY = 'shem_public_cart';

export const loadCart = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(CART_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const saveCart = (items) => {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event('shem-cart-updated'));
};

export const addToCart = (item) => {
  const current = loadCart();
  const existing = current.find((row) => row.id === item.id);
  if (existing) {
    const next = current.map((row) =>
      row.id === item.id ? { ...row, quantity: (row.quantity || 1) + 1 } : row
    );
    saveCart(next);
    return next;
  }
  const next = [...current, { ...item, quantity: 1 }];
  saveCart(next);
  return next;
};

export const removeFromCart = (id) => {
  const next = loadCart().filter((row) => row.id !== id);
  saveCart(next);
  return next;
};

export const updateCartQuantity = (id, quantity) => {
  const next = loadCart().map((row) => {
    if (row.id !== id) return row;
    const safeQty = Math.max(1, Number(quantity) || 1);
    return { ...row, quantity: safeQty };
  });
  saveCart(next);
  return next;
};

export const clearCart = () => {
  saveCart([]);
};

export const cartTotal = (items = []) =>
  items.reduce((sum, item) => sum + (Number(item.price) || 0) * (item.quantity || 1), 0);

